import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { baseUrl } from "../../../Environments/environment";

const CustomerSupportSocketContext = createContext(null);

export const CustomerSupportSocketProvider = ({
  children,
  authType,
  conversationToken,
  adminAccessToken,
}) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!authType) return;

    const auth =
      authType === "customer"
        ? { type: "customer", token: conversationToken }
        : { type: "admin", token: adminAccessToken ? `Bearer ${adminAccessToken}` : "" };

    if (authType === "customer" && !conversationToken) return;
    if (authType === "admin" && !adminAccessToken) return;

    const socketInstance = io(`${baseUrl}/customer-support`, { auth });
    setSocket(socketInstance);

    socketInstance.on("connect", () => setIsConnected(true));
    socketInstance.on("disconnect", () => setIsConnected(false));

    return () => {
      socketInstance.disconnect();
      setSocket(null);
      setIsConnected(false);
    };
  }, [authType, conversationToken, adminAccessToken]);

  return (
    <CustomerSupportSocketContext.Provider
      value={{ socket, isConnected }}
    >
      {children}
    </CustomerSupportSocketContext.Provider>
  );
};

export const useCustomerSupportSocket = () => {
  const context = useContext(CustomerSupportSocketContext);
  if (!context) {
    return { socket: null, isConnected: false };
  }
  return context;
};
